import React, { useEffect } from 'react';

import { ErrorPage } from '@tecma/ds';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
// import { datadogRum } from '@datadog/browser-rum';

import useDeviceDimension from 'hooks/useDeviceDimension';
import { Routes } from 'routes';
import { applicationInitActions } from 'store/sagas/application/init/init.actions';
import { applicationStateSelectors } from 'store/slices/applicationState/selectors';

import { PageLoader } from 'components/PageLoader';
import { Snackbar } from 'components/Snackbar';
import { SwiperProvider } from 'components/SwiperContext/SwiperContext';

import type { ProjectInfo } from 'types/project';
import Tracking from 'components/Tracking/Tracking';

// if (process.env.REACT_APP_NAMESPACE === "biz-tecma-prod") {
// datadogRum.init({
//     applicationId: 'a0004d7d-26a7-4ed0-8225-ea73439f1dd1',
//     clientToken: 'pub3d67a27b0ff5a9bafc19b33d8de54312',
//     // site refers to the Datadog site parameter of your organization
//     // see Getting Started with Datadog Sites
//     site: 'datadoghq.eu',
//     service: 'myhome-sell',
//     env: process.env.REACT_APP_NAMESPACE,
//     // Specify a version number to identify the deployed version of your application in Datadog
//     // version: '1.0.0',
//     sessionSampleRate: 100,
//     sessionReplaySampleRate: 20,
//     trackUserInteractions: true,
//     trackResources: true,
//     trackLongTasks: true,
//     defaultPrivacyLevel: 'mask-user-input',
// });
// }
const faviconMock =
  'https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o/initiatives/tecmasolutions/global/img/favicon.ico';

const App: React.FC = () => {
  useDeviceDimension();

  const dispatch = useDispatch();
  const isLoading = useSelector(applicationStateSelectors.selectIsLoading);
  const projectInfo = useSelector(applicationStateSelectors.selectProjectInfo) as ProjectInfo;
  const hasError = useSelector(applicationStateSelectors.selectHasError);
  const snackbar = useSelector(applicationStateSelectors.selectSnackbar);

  useEffect(() => {
    dispatch(applicationInitActions.initApplicationRequested());
  }, []);

  if (isLoading) return <PageLoader />;

  if (hasError) return <ErrorPage />;

  if (projectInfo) {
    return (
      <BrowserRouter>
        <Helmet>
          <link rel='icon' href={faviconMock} sizes='16x16' type='image/png' />
          <title>{projectInfo.pageTitles?.myHome}</title>
        </Helmet>
        <Tracking />
        <SwiperProvider>
          <Routes />
          <Snackbar {...snackbar} open={snackbar?.open ?? false} />
        </SwiperProvider>
      </BrowserRouter>
    );
  }
  return null;
};

export default App;
